var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AonDialog } from "../../components/core/AonDialog";
import { UuiFlexlayout, UuiInputTitle, UuiLogo } from "@aonunited/react";
import { AonButton } from "../../components/core/AonButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { BUTTON_VARIANT } from "../../components/core/AonButton/consts";
import React, { useState } from "react";
import { AonInput } from "../../components/core/AonInput";
import { handleClientAddRemoveChange } from "../../api/marketData/AllStaffCrud";
import { useAppInfoStore, useClientPageStore, useErrorStore, useNotificationStore } from "../../store";
import { useNavigate } from "react-router-dom";
export var AddRemoveUpdateClientDailog = function (props) {
    var AddDailogBody = function () {
        var appInfo = useAppInfoStore();
        var clientStore = useClientPageStore();
        var clientDetails = clientStore.selectedClientDetails;
        var _a = useState({
            name: "",
            purposed_name: clientDetails.name,
            additionalInfo: ""
        }), form = _a[0], setForm = _a[1];
        var notificationStore = useNotificationStore();
        var _b = useState(false), error = _b[0], setError = _b[1];
        var _c = useState(false), apiLoading = _c[0], setApiLoading = _c[1];
        var _d = useState(""), errorMsg = _d[0], setErrorMsg = _d[1];
        var placeHolderValAdd = "Please provide, country of domicile, web address or any other standard company identifiers, if available, to help the Market Security team approve this request.";
        var placeHolderValRest = "Any other information that will help the Market Security team approve this request...";
        var addtionalInfoTitleChange = "Provide Reason for Change";
        var addtionalInfoTitleDelete = "Rational for Removing Client";
        var navigation = useNavigate();
        var errorStore = useErrorStore();
        var saveForm = function (name, value, event) {
            if (event === void 0) { event = ""; }
            setForm(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
            });
        };
        var handledErrorMsg = function (msg) {
            setError(true);
            setErrorMsg(msg);
            var timoutInstance = setTimeout(function () {
                setErrorMsg("");
                clearTimeout(timoutInstance);
            }, 5000);
        };
        var onClickSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, Error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if ((props.action !== "ADD" && !form.purposed_name) || !form.additionalInfo || (props.action === "ADD" && !form.name)) {
                            handledErrorMsg("Mandatory field cannot be left blank!!!");
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        setApiLoading(true);
                        payload = {};
                        if (props.action === "ADD") {
                            payload = {
                                "requestType": "NC", //Hard Coaded for add new client
                                "clientName": form.name,
                                "requestorAdditionalinfo": form.additionalInfo,
                                "clientGuid": clientDetails.clientGuid,
                                "clientId": clientDetails.code,
                                //"requestorName": userInfo.displayName,
                                //"requestorEmail": requestorEmail,
                                //"oktaID":oktaID,
                            };
                        }
                        else if (props.action === "REMOVE") {
                            payload = {
                                "requestType": "RC",
                                "clientName": form.purposed_name,
                                "clientGuid": clientDetails.clientGuid,
                                "clientId": clientDetails.code,
                                "requestorAdditionalinfo": form.additionalInfo,
                                // "requestorName": userInfo.displayName,
                                //"requestorEmail": requestorEmail,
                                //"oktaID":oktaID
                            };
                        }
                        else {
                            payload = {
                                "requestType": "CC",
                                "clientName": clientDetails.name,
                                "proposedName": form.purposed_name,
                                "clientGuid": clientDetails.clientGuid,
                                "clientId": clientDetails.code,
                                "requestorAdditionalinfo": form.additionalInfo,
                                //"requestorName": userInfo.displayName,
                                //"requestorEmail": requestorEmail,
                                //"oktaID":oktaID
                            };
                        }
                        return [4 /*yield*/, handleClientAddRemoveChange(payload)];
                    case 2:
                        _a.sent();
                        notificationStore.showNotification({ message: "Request Submitted successfully", variant: "success", visible: true });
                        return [3 /*break*/, 5];
                    case 3:
                        Error_1 = _a.sent();
                        console.log(Error_1);
                        notificationStore.showNotification({ message: "Something went wrong! Please try again", variant: "error", visible: true });
                        errorStore.showError({ message: "Error", code: "500" });
                        navigation('/error');
                        return [3 /*break*/, 5];
                    case 4:
                        props.onClickClose();
                        setApiLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        return (React.createElement("div", null,
            props.action === "ADD" ?
                React.createElement(UuiFlexlayout, { direction: 'column', gap: 'xs' },
                    React.createElement(AonInput, { required: true, label: "Name", "aria-label": "Outlined", onTextChange: function (event) { return saveForm("name", event.target.value); }, value: form.name, type: "text", placeholder: 'Name' }),
                    React.createElement("div", null,
                        React.createElement(UuiInputTitle, null,
                            "Additioanal Info",
                            React.createElement("span", { style: { color: "red" } }, "*"))),
                    React.createElement("textarea", { required: true, rows: 6, cols: 72, style: { borderRadius: "5px", borderWidth: "1px", borderColor: "grey" }, onChange: function (event) { return saveForm("additionalInfo", event.target.value); }, value: form.additionalInfo, placeholder: placeHolderValAdd })) :
                React.createElement(UuiFlexlayout, { direction: 'column', gap: 'xs' },
                    React.createElement(AonInput, { required: true, disabled: props.action === "REMOVE" ? true : false, label: "Name", "aria-label": "Outlined", onTextChange: function (event) { return saveForm("purposed_name", event.target.value); }, value: form.purposed_name, type: "text", placeholder: 'Name' }),
                    React.createElement("div", null,
                        React.createElement(UuiInputTitle, null,
                            props.action === "REMOVE" ? addtionalInfoTitleDelete : addtionalInfoTitleChange,
                            React.createElement("span", { style: { color: "red" } }, "*"))),
                    React.createElement("textarea", { required: true, rows: 6, cols: 72, style: { borderRadius: "5px", borderWidth: "1px", borderColor: "grey" }, onChange: function (event) { return saveForm("additionalInfo", event.target.value); }, value: form.additionalInfo, placeholder: placeHolderValRest })),
            React.createElement(UuiFlexlayout, { style: { marginBlock: "10px" }, direction: 'row', gap: 'xs' }, error && errorMsg && React.createElement("div", { style: { color: "red" } }, errorMsg)),
            React.createElement("div", { style: { marginTop: "10px", marginBottom: "-25px", display: "flex", } },
                apiLoading ? React.createElement("div", null, "Loading...") :
                    React.createElement(AonButton, { style: { marginRight: "10px" }, variant: BUTTON_VARIANT.DEFAULT, onClick: function () {
                            onClickSubmit();
                        } }, "Submit"),
                React.createElement(AonButton, { style: { marginRight: "10px" }, variant: BUTTON_VARIANT.PROMINENT, onClick: props.onClickClose }, "Cancel"))));
    };
    return React.createElement(AonDialog, { dismissOnEsc: false, opened: props.showDailog, dismissOnOverlay: false, enableBackgroundScroll: false, header: React.createElement("div", { className: 'header' },
            React.createElement("div", { className: 'logo_about_dialog' },
                React.createElement(UuiLogo, { onClick: function () { } })),
            React.createElement(FontAwesomeIcon, { className: 'text-icon', icon: faClose, onClick: props.onClickClose })), body: React.createElement(AddDailogBody, null) });
};
